import MoreHorizOutlinedIcon from '@material-ui/icons/MoreHorizOutlined';
import MoreVertOutlinedIcon from '@material-ui/icons/MoreVertOutlined';
import _ from 'lodash';
import { changeDesignWeb } from '../../apis/firebase';
import { ERROR_CHANGE_DESIGN, SUCCESS_UPDATE_TEXT } from '../../constants';
import verticalProduct from '../../assets/pictures/verticalProduct.png';
import horizontalProduct from '../../assets/pictures/horizontalProduct.png';
import { showNotification } from '../../components/Notification/Notification.view'

export const initStates = async (setStateObj, webapp, productStyle, sectionOrientation) => {
  if (!productStyle) productStyle = webapp.productStyle || ''
  if (!sectionOrientation) sectionOrientation = webapp.sectionOrientation || ''

  const {
    images = {},
    phrases = {}
  } = webapp;
  const { cartPhrase } = phrases
  const { imageCoverOrderUrl = '' } = images
  await setStateObj({
    cartPhrase,
    isLoading: false,
    selectedMenu: sectionOrientation === 'horizontal' ? 0 : 1,
    selectedProduct: productStyle === 'list' ? 0 : 1,
    picture: imageCoverOrderUrl,
    image64: imageCoverOrderUrl

  });
};
export const setCroppedImage = async (croppedImage, setStateObj) => {
  setStateObj({ image64: croppedImage.split(',')[1] });
};
export const handleRemoveImage = setStateObj => {
  setStateObj({ image64: '' });
};


export const changeDesign = async (stateObj, webapp, openErrorModal, setStateObj) => {
  const { selectedProduct, selectedMenu, image64, cartPhrase, random } = stateObj;
  const sectionOrientation = selectedMenu === 0 ? 'horizontal' : 'vertical';
  const productStyle = selectedProduct === 0 ? 'list' : 'grid';
  try {
    setStateObj({
      spinner: true
    });
    await changeDesignWeb(image64, sectionOrientation, productStyle, cartPhrase);
    showNotification(
      'light',
      'ltr',
      'primary',
      SUCCESS_UPDATE_TEXT,
      `Les paramétres de design application web ont bien été modifiés.`
    );
    initStates(setStateObj, webapp, productStyle, sectionOrientation)
    setStateObj({
      random: random + 1
    });

  } catch (e) {
    openErrorModal(ERROR_CHANGE_DESIGN);
  }

  setStateObj({
    spinner: false
  });
}

export const changeSwitchValue = (newValue, imageCoverOrderUrl, setStateObj) => {
  setStateObj({
    picture: imageCoverOrderUrl,
    selected: newValue
  });
}

export const changeSwitchValueMode = async (event, newValue, setStateObj, idCheck) => {
  if (idCheck === 'menuCheck') {
    await setStateObj({
      selectedMenu: newValue
    });
  } else {
    await setStateObj({
      selectedProduct: newValue
    });
  }
};

export const changeValueMode = (selectedMenu, selectedProduct, idCheck, setStateObj) => {
  idCheck === 'menuCheck'
    ? setStateObj({ selectedMenu: selectedMenu === 1 ? 0 : 1 })
    : setStateObj({ selectedProduct: selectedProduct === 1 ? 0 : 1 });
}

export const getCommonBottomNavigationData = (classes, idCheck) => {
  const data = ['Horizontal', 'vertical'];
  const newData = [];
  _.map(data, e => {
    newData.push({
      label: e,
      icon:
        e === data[0] ? (
          idCheck === 'menuCheck' ? (
            <MoreHorizOutlinedIcon className={classes.iconStyle} />
          ) : (
            <img src={horizontalProduct} alt='' className={classes.horizontalProductIcon} />
          )
        ) : idCheck === 'menuCheck' ? (
          <MoreVertOutlinedIcon className={classes.iconStyle} />
        ) : (
          <img src={verticalProduct} alt='' className={classes.verticalProductIcon} />
        )
    });
  });
  return newData;
};
